
import { AuthModel } from '@gtpl/shared-models/common-models';
import { Module } from '@nestjs/common';
import { RedisHelperService } from './redis-helper.service';
@Module({
    imports: [
    ],
    controllers: [],
    providers: [RedisHelperService, AuthModel],
    exports: [RedisHelperService, AuthModel],
})

export class RedisHelperModule { }

